import React, {useState} from "react";
import {Box, Stack, Text, View, usePatronTheme} from "@unibuddy/patron";
import styled from "styled-components";
import {useAnalytics} from "@unibuddy/tracking";

import {questions} from "./questions";
import {chatTheme} from "../../../../utils/theme/chatTheme";
import {IconChevronDown} from "../../../../icons";
import {useAssistantConversationContext} from "../../providers/AssistantConversationProvider";
import {events} from "../../../../analytics/productSpecification";
import {useUniversityContext} from "../../../../providers/UniversityProvider";

const SUGGESTED_QUESTIONS_TO_SHOW = 2;

const IconChevronRight = styled(IconChevronDown)`
    transform: rotate(270deg);
`;

type GetRandomNumberProps = {
    max: number;
    rerollValues: number[];
};

function getRandomNumber({max = 1, rerollValues}: GetRandomNumberProps): number {
    const number = Math.floor(Math.random() * max);
    if (rerollValues.includes(number)) {
        return getRandomNumber({max, rerollValues});
    }
    if (number === max) return number - 1;
    return number;
}

export function ChatSuggestedQuestions() {
    const {onSendMessage} = useAssistantConversationContext();
    const {universitySlug} = useUniversityContext();
    const {trackEvent} = useAnalytics();
    const theme = usePatronTheme();
    const [randomQuestionIndices, setRandomQuestionIndices] = useState<number[]>([]);

    if (randomQuestionIndices.length < SUGGESTED_QUESTIONS_TO_SHOW) {
        setRandomQuestionIndices((prevIndices) => [
            ...prevIndices,
            getRandomNumber({max: questions.length, rerollValues: prevIndices}),
        ]);
    }

    return (
        <View
            bgColor={chatTheme.chat.scroll.backgroundColor}
            width="100%"
            paddingX="small-medium"
            marginTop="small"
            alignItems="flex-end"
        >
            <Stack space="small" align="right">
                {randomQuestionIndices.map((index) => (
                    <Box
                        key={questions[index].question}
                        as="button"
                        borderWidth={1}
                        borderColor={theme.colors.primaryColor}
                        borderRadius="xsmall"
                        padding="small"
                        width="fit-content"
                        display="flex"
                        gap="xxsmall"
                        alignItems="center"
                        className="bubble"
                        color={theme.colors.primaryColor}
                        _hover={{bgColor: theme.colors.primaryColor, color: "white"}}
                        onClick={() => {
                            onSendMessage(questions[index].question);
                            trackEvent(events.questionPromptClicked.name, {
                                product: "Assistant",
                                cta: questions[index].question,
                                universitySlug,
                            });
                        }}
                    >
                        <Text color="inherit" align="left">
                            {questions[index].question}
                        </Text>
                        <Box flexShrink={0} w="16px" h="16px" color="inherit">
                            <IconChevronRight />
                        </Box>
                    </Box>
                ))}
            </Stack>
        </View>
    );
}
